import { IconProps } from 'types/icon.type'

export const SortIcon = (props: IconProps) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Sort icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64139 2.89155C5.88547 2.64748 6.2812 2.64748 6.52528 2.89155L9.85861 6.22489C10.1027 6.46897 10.1027 6.86469 9.85861 7.10877C9.61453 7.35285 9.2188 7.35285 8.97472 7.10877L6.70833 4.84238V16.6668C6.70833 17.012 6.42851 17.2918 6.08333 17.2918C5.73816 17.2918 5.45833 17.012 5.45833 16.6668V4.84238L3.19194 7.10877C2.94786 7.35285 2.55214 7.35285 2.30806 7.10877C2.06398 6.86469 2.06398 6.46897 2.30806 6.22489L5.64139 2.89155ZM14.4167 2.7085C14.7618 2.7085 15.0417 2.98832 15.0417 3.3335V15.1579L17.3081 12.8916C17.5521 12.6475 17.9479 12.6475 18.1919 12.8916C18.436 13.1356 18.436 13.5314 18.1919 13.7754L14.8586 17.1088C14.6145 17.3528 14.2188 17.3528 13.9747 17.1088L10.6414 13.7754C10.3973 13.5314 10.3973 13.1356 10.6414 12.8916C10.8855 12.6475 11.2812 12.6475 11.5253 12.8916L13.7917 15.1579V3.3335C13.7917 2.98832 14.0715 2.7085 14.4167 2.7085Z"
        fill="currentColor"
      />
    </svg>
  )
}
